/** Class names on Modal.Content that use viewport-limited height + internal scroll. */
export const REPOSITORIO_MODAL_CONTENT_WRAPPERS = [
  'repositorio-upload-modal-content-wrapper',
  'repositorio-notification-modal-content-wrapper',
  'email-plantillas-modal-content',
];

/**
 * Modal de detalle de documento: solo es un hook CSS (ver TaxDocumentDetail.css).
 * NO se registra en los sets de scroll/altura para que Modal.Content NO genere su
 * propio scroll; el scroll vive únicamente en .tab-content (igual que antes del
 * commit del modal), pero ahora con flex + min-height:0 → Safari-friendly.
 */
export const DOCUMENT_DETAIL_MODAL_CONTENT_CLASS = 'document-detail-modal-content';

const SCROLLABLE_MAX_HEIGHT_CLASSES = new Set([
  'cobranza-email-modal-content-wrapper',
  'f29-email-modal-content-wrapper',
  'cpv-email-modal-content-wrapper',
  'vincular-documento-modal-content-wrapper',
  'tc-assign-doc-modal-content-wrapper',
  'create-journal-entry-modal-content-wrapper',
  'match-row-revisar-match-modal-content-wrapper',
  'saldo-inicial-modal-content-wrapper',
  'bitacora-notification-modal-content-wrapper',
  'auditor-book-detail-modal-content-wrapper',
  'hmr-modal-content-wrapper',
  'entry-history-modal-content-wrapper',
  ...REPOSITORIO_MODAL_CONTENT_WRAPPERS,
]);

const SCROLLABLE_OVERFLOW_CLASSES = new Set([
  ...SCROLLABLE_MAX_HEIGHT_CLASSES,
  'bitacora-modal-content-wrapper',
]);

const FLEX_FILL_CLASSES = new Set([
  'cobranza-email-modal-content-wrapper',
  'f29-email-modal-content-wrapper',
  'cpv-email-modal-content-wrapper',
  'vincular-documento-modal-content-wrapper',
  'tc-assign-doc-modal-content-wrapper',
  'create-journal-entry-modal-content-wrapper',
  'match-row-revisar-match-modal-content-wrapper',
  'saldo-inicial-modal-content-wrapper',
  'bitacora-modal-content-wrapper',
  'bitacora-notification-modal-content-wrapper',
  'auditor-book-detail-modal-content-wrapper',
  'hmr-modal-content-wrapper',
  'entry-history-modal-content-wrapper',
  ...REPOSITORIO_MODAL_CONTENT_WRAPPERS,
]);

const MIN_HEIGHT_SCROLL_CLASSES = new Set([
  'vincular-documento-modal-content-wrapper',
  'tc-assign-doc-modal-content-wrapper',
  'create-journal-entry-modal-content-wrapper',
  'match-row-revisar-match-modal-content-wrapper',
  'saldo-inicial-modal-content-wrapper',
  'bitacora-notification-modal-content-wrapper',
  'auditor-book-detail-modal-content-wrapper',
  'hmr-modal-content-wrapper',
  'entry-history-modal-content-wrapper',
]);

/**
 * Contenido que ocupa todo el alto disponible del modal y NO scrollea él mismo:
 * el scroll vive en un hijo (una tabla, un panel). Se usa cuando el modal tiene
 * alto fijo y el contenido debe estirarse para llenarlo.
 */
const FLEX_COLUMN_FILL_CLASSES = new Set([
  'reconcile-rule-modal-content',
  'composicion-cuenta-modal-content',
  'comentario-celda-modal-content',
  'possible-duplicate-modal-content',
  'cuentas-asignadas-modal-content',
  'importar-estructura-modal-content',
  'create-company-modal-body',
]);

/** Modal alto (ReconcileRuleModal): scroll interno; className puede incluir varias tokens */
function classNameHasToken(classNameContent, token) {
  if (!classNameContent || !token) return false;
  return classNameContent.trim().split(/\s+/).includes(token);
}

/**
 * Inline styles for Modal.Content based on optional content wrapper class name.
 * @param {string|undefined} classNameContent
 * @returns {import('react').CSSProperties}
 */
export function getCustomModalContentStyle(classNameContent) {
  const c = classNameContent || '';
  if ([...FLEX_COLUMN_FILL_CLASSES].some((token) => classNameHasToken(c, token))) {
    return {
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      flex: '1 1 auto',
      minHeight: 0,
      maxHeight: '100%',
      padding: 0,
    };
  }
  const isBitacora = c === 'bitacora-modal-content-wrapper';
  const hasMaxHeight = SCROLLABLE_MAX_HEIGHT_CLASSES.has(c);
  const hasOverflowAuto = SCROLLABLE_OVERFLOW_CLASSES.has(c);
  const flexFill = FLEX_FILL_CLASSES.has(c);
  const minHeightCalc = REPOSITORIO_MODAL_CONTENT_WRAPPERS.includes(c)
    ? 0
    : MIN_HEIGHT_SCROLL_CLASSES.has(c)
      ? 'calc(90vh - 150px)'
      : 'none';

  return {
    overflow: hasOverflowAuto ? 'auto' : 'visible',
    display: 'flex',
    flexDirection: 'column',
    maxHeight: isBitacora ? 'none' : hasMaxHeight ? 'calc(90vh - 150px)' : 'none',
    minHeight: isBitacora ? 0 : REPOSITORIO_MODAL_CONTENT_WRAPPERS.includes(c) ? 0 : minHeightCalc,
    flex: flexFill ? '1 1 0' : undefined,
  };
}
